import React, { Component } from 'react'
import { Card, Elevation, Tooltip, Position } from "@blueprintjs/core"

import axios from '../../../services/axios'
import storage from '../../../services/storage'
import numeral from 'numeral'
import moment from 'moment'
import _ from 'lodash'
import { Competitors } from '../../../config'

import logo from '../../../assets/img/logo.png'

import Loads, { createLoader } from 'react-loads'
import Loading from '../../Shared/LoadingCharts'
import Title from '../../Shared/TitleChart'
import IndustryError from '../../Shared/IndustryError'
import Reload from '../../Shared/ReloadChart'
import Error from '../../Shared/ErrorChart'
import './styles.css'

class LinksInCount extends Component {
  constructor(props){
    super(props)

    this.state = {
      data: []
    }

    this.reload = 0
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.loading = this.loading.bind(this)

    this.chart = this.chart.bind(this)
    this.getData = this.getData.bind(this)
  }

  getData(range){
    return Promise.all([storage.get('page'), storage.range()])
    .then((responses)=>{
      const since = moment(responses[1][0]).format('YYYY-MM-DD')
      const until = moment(responses[1][1]).format('YYYY-MM-DD')

      return axios.get(`industry/alexa/${responses[0]}?since=${since}&until=${until}`)
    }).then((response)=>{
      return _.orderBy(response.data.data, 'linksInCount', 'desc')
    })
  }

  chart(data){
    return data.length ? (
      data.map((item, index)=>{
        return (
          <div className={`trendingLinksInCountItem ${Competitors < 5 && 'trendingLinksInCountItemFull'}`}>
            <div className="trendingLinksInCountItemContainer">
              <div className="trendingLinksInCountImage">
                <img src={!item.brand.image || item.brand.image == "" ? logo : item.brand.image} alt="logo" />
              </div>
              <div className="trendingLinksInCountInfo">
                <p className="trendingLinksInCountValue">
                  {numeral(item.linksInCount).format('0,0')}
                </p>
              </div>
            </div>
          </div>
        )
      })
    ) : (
      <IndustryError />
    )
  }

  success({ response, load }){
    const data = response
    const Chart = this.chart(data)

    return (
      <div>
        {Chart}
      </div>
    )
  }

  error({ error, load }){
    switch(true){
      case this.reload < 6:
        this.reload++
        load()
        return (<Loading />)
      break

      case this.reload < 10:
        return (<Reload onReload={()=>{
          this.reload++
          load()
        }} />)
      break

      case this.reload > 9:
        return (<Error 
          error={error.message} 
        />)
      break
    }
  }

  shouldComponentUpdate(props){
    return !_.isEqual(this.props, props)
  }

  loading(){
    return (
      <Loading />
    )
  }

  render() {
    const Chart = createLoader({
      load: () => this.getData(this.props.range)
    })

    return (
      <Card 
        interactive={false} 
        elevation={Elevation.TWO} 
        className="no-pad-t-b"
        id="trendingLinksInCount">
        <Title description='El número de sitios que apuntan trafico hacia la marca y su competencia.' title='Links in Count' />
        <div className='trendingLinksInCountContainer'>
          <Chart loadOnMount>
            <Chart.Loading>
              {this.loading()}
            </Chart.Loading>
            <Chart.Success>
              {this.success}
            </Chart.Success>
            <Chart.Error>
              {this.error}
            </Chart.Error>
          </Chart>
        </div>
      </Card>
    )
  }
}

export default LinksInCount



// WEBPACK FOOTER //
// ./src/components/IndustryIntelligence/LinksInCount/index.js